var map = {
	"./account_center_logo.svg": 1032,
	"./account_center_only_logo.svg": 1033,
	"./arrow_blue_right.svg": 1034,
	"./arrow_dropdown_blue.svg": 1035,
	"./arrow_left.svg": 1036,
	"./checkbox_default.svg": 1037,
	"./checkbox_selected.svg": 1038,
	"./circle_bookshelf_sm.svg": 1039,
	"./circle_bookshelf_sm_hover.svg": 1040,
	"./circle_support.svg": 1041,
	"./circle_support_hover.svg": 1042,
	"./circle_support_sm.svg": 1043,
	"./circle_support_sm_hover.svg": 1044,
	"./devices.svg": 1045,
	"./error.svg": 1046,
	"./error_icon.svg": 1047,
	"./external_window.svg": 1048,
	"./external_window_white.svg": 1049,
	"./i_icon.svg": 1050,
	"./loader.svg": 1051,
	"./logo.svg": 1052,
	"./logo_ac.svg": 1053,
	"./mobile.svg": 1054,
	"./preferences.svg": 1055,
	"./radio_button_default.svg": 1056,
	"./radio_button_selected.svg": 1057,
	"./resources.svg": 1058,
	"./sign_out.svg": 1059,
	"./sort_icon.svg": 1060,
	"./success.svg": 1061,
	"./success_icon.svg": 1062,
	"./transactions.svg": 430,
	"./user.svg": 1063,
	"./user_info.svg": 1064,
	"./vitalsource_color.svg": 1065
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1066;



/*****************
 ** WEBPACK FOOTER
 ** ./src/img ./~/svg-inline-loader?removeSVGTagAttrs=false!\.svg$
 ** module id = 1066
 ** module chunks = 0
 **/